import React from "react";
import "./DataHolder.scss";
import {ProgressPercentageComponent} from "./ProgressPercentageComponent"
export const TotalRecordsComponent = ({ title, subTitle,changeType,changeValue }) => {
    return (
        <div className="box_design">
            <div>
                <p className="title_for_total_records_component ">{title}</p>
            </div>
            <div>
                <p className="sub_title_for_total_records_component">{subTitle}</p>
            </div>
            <div >
                <ProgressPercentageComponent changeInValue={changeType} percentageValue={changeValue}></ProgressPercentageComponent>
            </div>
        </div>
    );
};
